module.exports = __webpack_public_path__ + "media/next-player.8fb75c98.wav";